import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ContentTitle } from '../../../components/utilities/styledComponents/ContentTitle';
import {
    Container,
    StyledTitle,
    PreviewContainer,
    PreviewColumn,
    StyledSubTitle,
    StyledText,
    ContainerTitle,
} from './style';
import Button from '../../../components/Campanhas/Button';
// Assets
// Basic Tier
import BasicCar1 from '../../../img/sites/previews/basic/carro_1.png';
import BasicCar2 from '../../../img/sites/previews/basic/carro_2.png';
import BasicCar3 from '../../../img/sites/previews/basic/carro_3.png';
import BasicCar4 from '../../../img/sites/previews/basic/carro_4.png';
import BasicCar5 from '../../../img/sites/previews/basic/carro_5.png';
import BasicBike1 from '../../../img/sites/previews/basic/moto_1.png';
import BasicBike2 from '../../../img/sites/previews/basic/moto_2.png';
import BasicBike3 from '../../../img/sites/previews/basic/moto_3.png';
import BasicBike4 from '../../../img/sites/previews/basic/moto_4.png';
import BasicBike5 from '../../../img/sites/previews/basic/moto_5.png';
// Personalized Tier
import CustomCar1 from '../../../img/sites/previews/personalized/carro_1.png';
import CustomCar2 from '../../../img/sites/previews/personalized/carro_2.png';
import CustomCar3 from '../../../img/sites/previews/personalized/carro_3.png';
import CustomCar4 from '../../../img/sites/previews/personalized/carro_4.png';
import CustomCar5 from '../../../img/sites/previews/personalized/carro_5.png';
import CustomBike1 from '../../../img/sites/previews/personalized/moto_1.png';
import CustomBike2 from '../../../img/sites/previews/personalized/moto_2.png';
import CustomBike3 from '../../../img/sites/previews/personalized/moto_3.png';
import CustomBike4 from '../../../img/sites/previews/personalized/moto_4.png';
import CustomBike5 from '../../../img/sites/previews/personalized/moto_5.png';
// Pro Tier
import Pro1 from '../../../img/sites/previews/pro/pro1.png';
import Pro2 from '../../../img/sites/previews/pro/pro2.png';
import Pro3 from '../../../img/sites/previews/pro/pro3.png';
import Pro4 from '../../../img/sites/previews/pro/pro4.png';
import Pro5 from '../../../img/sites/previews/pro/pro5.png';

const SitePreview = () => {
    const { tier } = useParams();

    const sitesData = {
        basico: {
            title: 'Básico',
            previews: [
                {
                    name: 'Básico 1 - Carro',
                    image: BasicCar1,
                    url: 'http://layoutb1.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 2 - Carro',
                    image: BasicCar2,
                    url: 'http://layoutb2.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 3 - Carro',
                    image: BasicCar3,
                    url: 'http://layoutb3.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 4 - Carro',
                    image: BasicCar4,
                    url: 'http://layoutb4.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 5 - Carro',
                    image: BasicCar5,
                    url: 'http://layoutb5.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 1 - Moto',
                    image: BasicBike1,
                    url: 'https://layoutb1moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 2 - Moto',
                    image: BasicBike2,
                    url: 'https://layoutb2moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 3 - Moto',
                    image: BasicBike3,
                    url: 'https://layoutb3moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 4 - Moto',
                    image: BasicBike4,
                    url: 'https://layoutb4moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Básico 5 - Moto',
                    image: BasicBike5,
                    url: 'https://layoutb5moto.sitewebmotors.com.br/',
                },
            ],
        },
        personalizado: {
            title: 'Personalizado',
            previews: [
                {
                    name: 'Personalizado 1 - Carro',
                    image: CustomCar1,
                    url: 'http://layoutp1.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 2 - Carro',
                    image: CustomCar2,
                    url: 'http://layoutp2.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 3 - Carro',
                    image: CustomCar3,
                    url: 'http://layoutp3.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 4 - Carro',
                    image: CustomCar4,
                    url: 'http://layoutp4.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 5 - Carro',
                    image: CustomCar5,
                    url: 'http://layoutp5.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 1 - Moto',
                    image: CustomBike1,
                    url: 'https://layoutp1moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 2 - Moto',
                    image: CustomBike2,
                    url: 'https://layoutp2moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 3 - Moto',
                    image: CustomBike3,
                    url: 'https://layoutp3moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 4 - Moto',
                    image: CustomBike4,
                    url: 'https://layoutp4moto.sitewebmotors.com.br/',
                },
                {
                    name: 'Personalizado 5 - Moto',
                    image: CustomBike5,
                    url: 'https://layoutp5moto.sitewebmotors.com.br/',
                },
            ],
        },
        pro: {
            title: 'Pro',
            previews: [
                {
                    name: 'Pro 1',
                    image: Pro1,
                    url: 'https://layoutpr1.sitewebmotors.com.br/',
                },
                {
                    name: 'Pro 2',
                    image: Pro2,
                    url: 'http://layoutpro2.sitewebmotors.com.br/home',
                },
                {
                    name: 'Pro 3',
                    image: Pro3,
                    url: 'http://layoutpro3.sitewebmotors.com.br/home',
                },
                {
                    name: 'Pro 4',
                    image: Pro4,
                    url: 'http://layoutpro4.sitewebmotors.com.br/home',
                },
                {
                    name: 'Pro 5',
                    image: Pro5,
                    url: 'http://layoutpro5.sitewebmotors.com.br/home',
                },
            ],
        },
    };

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const PreviewCard = ({ name, image, url }) => (
	<PreviewContainer>
		<PreviewColumn>
			<img src={image} alt={name} />
		</PreviewColumn>
		<PreviewColumn width="60%" className="secondColumn">
			<StyledTitle textAlign="left" fontSize="20px">Modelo <span>{name}</span></StyledTitle>
			<StyledSubTitle>Clique em ver modelo para conhecer o site.</StyledSubTitle>
			<div style={{ width: '138px' }}>
				<Button
					padding="9px"
					onClick={(e) => {
                        e.preventDefault();
                        window.open(url);
                    }}
					type="link"
				>Ver modelo
				</Button>
			</div>
		</PreviewColumn>
	</PreviewContainer>
    );
	document.title = 'Site';
    return (
	<>
		<div className="page-container">
			<article id="home-page">
				<div className="content-welcome p-0">
					<ContentTitle fontSize="32px">Sites</ContentTitle>
				</div>
			</article>
		</div>
		<div style={{ padding: '30px 30px 0' }}>
			<ContainerTitle>
				<StyledTitle
					textTransform="uppercase"
					fontSize="20px"
					fontWeight="bold"
					lineHeight="23px"
				>
					Site <span>{sitesData[tier].title}</span>
				</StyledTitle>
				<StyledText>
					<p>Solução ideal para
						<br />
						<span>Lojas pequenas e médias</span>
					</p>
				</StyledText>
			</ContainerTitle>
		</div>
		<div style={{ padding: '0 30px 30px' }}>
			<Container>
				{sitesData[tier].previews.map(sitePreview => (
					<PreviewCard
						name={sitePreview.name}
						image={sitePreview.image}
						url={sitePreview.url}
					/>
                ))}
			</Container>
		</div>
	</>
    );
};

export default SitePreview;
